import { Component, EventEmitter, Injector, OnInit, Output } from '@angular/core';
import { AgendaDto, CreateEventoDto, EventoServiceProxy, TipoEvento } from "@shared/service-proxies/service-proxies";
import { BsModalRef } from 'ngx-bootstrap/modal';
import { AppComponentBase } from '@shared/app-component-base';
import { finalize } from 'rxjs/operators';
import * as moment from 'moment';

@Component({
  selector: 'app-create-evento',
  templateUrl: './create-evento.component.html',
  styleUrls: ['./create-evento.component.scss']
})
export class CreateEventoComponent extends AppComponentBase implements OnInit {
  public evento: CreateEventoDto = undefined;
  public agenda: AgendaDto;
  protected saving: boolean = false;
  protected data: string;
  protected horaInicio: string;
  protected horaFim: string;
  protected ehDiaTodo: boolean = false;
  @Output() onSave = new EventEmitter<any>();

  constructor(
    injector: Injector,
    private _eventoService: EventoServiceProxy,
    public bsModalRef: BsModalRef
  ) { super(injector) }

  ngOnInit(): void {
    if (this.evento) {
      this.data = this.evento.inicio.format("YYYY-MM-DD");
      this.horaFim = this.evento.fim.format("HH:mm");
      this.horaInicio = this.evento.inicio.format("HH:mm");
    } else {
      this.evento = new CreateEventoDto();
    }
  }

  private combinarDataHora(data: string, hora: string): moment.Moment | null {
    if (!data || !hora) return null;

    const dataHoraStr = `${data} ${hora}`;

    return moment.utc(dataHoraStr, 'YYYY-MM-DD HH:mm');
  }

  public save(): void {
    const inicio = this.combinarDataHora(this.data, this.horaInicio);
    const fim = this.combinarDataHora(this.data, this.horaFim);

    if (!inicio || !fim) {
      this.message.warn('Preencha corretamente a data e os horários.');
      return;
    }

    if (!fim.isAfter(inicio)) {
      this.message.warn('O horário final deve ser maior que o horário inicial.');
      return;
    }

    this.saving = true;
    abp.ui.setBusy();

    this.evento.agendaId = this.agenda.id;
    this.evento.pacienteId = null;
    this.evento.clinicaId = this.appSession.clinicaId;
    this.evento.profissionalId = this.appSession.profissionalId;
    this.evento.inicio = inicio;
    this.evento.fim = fim;
    this.evento.tipo = TipoEvento._1;

    this._eventoService.create(this.evento)
      .pipe(
        finalize(() => {
          abp.ui.clearBusy();
          this.saving = false;
        })
      )
      .subscribe(() => {
        this.onSave.emit();
        this.bsModalRef.hide();
      })
  }

  protected checkDiaTodo(): void {
    this.ehDiaTodo = !this.ehDiaTodo;

    if(this.ehDiaTodo){
      this.horaInicio = this.agenda.horarioInicio
      this.horaFim = this.agenda.horarioFim;
    }else{
      this.horaInicio = "";
      this.horaFim = "";
    }
  }
}
